export default __webpack_public_path__ + "static/media/commercial-cleaning.b3d71dce.svg";